/* @flow */

import * as React from 'react';
import classNames from 'classnames';
import noop from 'lodash/noop';
import StatusIcon from 'app/components/challenge/StatusIcon';
import Tappable from '../commons/Tappable';
import useSheet from '../../jss';

type Props = {
  classes: Object,
  data: Array<Object>,
  onSelect?: () => void,
  scheme?: 'dark' | 'light',
  statusFilters?: Object
};

const defaultProps = {
  onSelect: noop,
  scheme: 'light',
  statusFilters: {}
};

function PlayersCountDisplay({ classes, data, onSelect, scheme, statusFilters }: Props) {
  return (
    <div className={classNames(classes.statuses, scheme)}>
      {(data || []).map(({ id, count, iconType }) => (
        <Tappable
          key={id}
          component="div"
          className={classes.statusContainer}
          disabled={count === 0}
          onTap={() => onSelect(id)}
        >
          <div
            className={classNames(classes.statusIconContainer, {
              active: statusFilters[id],
              hoverable: onSelect !== noop
            })}
          >
            <StatusIcon statusId={id} iconType={iconType} />
          </div>
          <div className={classes.statusNumberContainer}>
            <span>{count}</span>
          </div>
        </Tappable>
      ))}
    </div>
  );
}

PlayersCountDisplay.defaultProps = defaultProps;

function applyStyles(theme: Theme) {
  return {
    icon: {
      marginTop: 4
    },
    statuses: {
      display: 'flex',
      flexGrow: 1,
      justifyContent: 'center',
      '&.dark': {}
    },
    statusContainer: {
      display: 'flex',
      paddingLeft: 2,
      paddingRight: 2
    },
    statusIconContainer: {
      alignItems: 'center',
      borderColor: 'currentColor',
      borderRadius: '50%',
      borderStyle: 'solid',
      borderWidth: 2,
      display: 'flex',
      flexGrow: 0,
      flexShrink: 0,
      fontSize: '0.8rem',
      height: 24,
      justifyContent: 'center',
      width: 24,
      '&.hoverable:hover, &.active': {
        transition: 'color 0.1s linear, background-color 0.1s linear, border-color 0.1s linear',
        backgroundColor: theme.color.white,
        color: theme.color.basis5
      },
      '$statuses.dark &': {
        color: theme.color.basis5
      }
    },
    statusNumberContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: theme.color.white,
      borderRadius: '50%',
      color: theme.color.basis2,
      flexGrow: 0,
      flexShrink: 0,
      fontSize: 10,
      height: 16,
      marginLeft: -5,
      width: 16,
      '$statuses.dark &': {
        backgroundColor: theme.color.basis4,
        color: theme.color.white
      }
    }
  };
}

export default useSheet(applyStyles)(PlayersCountDisplay);
